import React, { Component } from 'react'
import { Form, Input, Row, Col } from 'antd'
import Label from '../form/Label'
import LoginModal from './LoginModal'
import UserService from '../../services/UserService'
import _ from 'lodash'
import autofill from '../../utils/AutoFillWrapper'
import { formatPhoneNumber } from '../../utils/Util'
const FormItem = Form.Item

@autofill
class ProfileInfoFields extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoggedIn && this.props.isLoggedIn !== nextProps.isLoggedIn) {
      this.props.form.setFields({
        email: {
          errors: null
        }
      })
    }
  }

  onPhoneNumberChange = event => {
    event.target.value = formatPhoneNumber(event.target.value)
  }

  /**
   * Validates the password input
   */
  validatePassword = (rule, value, callback) => {
    if (!value) {
      callback('The password you provide must be at least 8 characters')
    } else if (value.length < 8) {
      callback('The password you provide must be at least 8 characters')
    } else {
      callback()
    }
  }

  /**
   * Validates confirm input
   */
  validateConfirm = (rule, value, callback) => {
    const form = this.props.form

    value !== form.getFieldValue('password')
      ? callback('The password must match the entry above to confirm')
      : callback()
  }

  /**
   * Validates phone number input
   */
  validatePhone = (rule, value, callback) => {
    // TODO: ms - use phone validator library to validate phone number
    let phone = value.replace(/[^\d]|/g, '')
    if (!value) {
      callback('Please enter a valid phone number')
    } else if (phone.length !== 10) {
      callback('Please enter a 10 digit phone number')
    } else {
      callback()
    }
  }

  /*
  * Checks if emailid already exists or not 
  */
  isEmailExist = async (rule, value, callback) => {
    //if user is loggedin, skip the check
    if (this.props.isLoggedIn) {
      callback()
      return
    }
    const emailExists = await UserService.isEmailExist(value)
    if (!emailExists) {
      callback()
    } else {
      callback('Email already exists')
    }
  }

  onLoginClick() {
    this.loginModalComponent.showLoginModal()
  }

  render() {
    const { getFieldDecorator, user, isLoggedIn } = this.props
    return (
      <div ref={c => (this.formRef = c)}>
        <Row gutter={34}>
          <Col xs={24} sm={12}>
            <FormItem label={Label('First Name')} hasFeedback>
              {getFieldDecorator('firstName', {
                rules: [
                  {
                    required: true,
                    message: 'Please enter first name matching ID'
                  }
                ],
                initialValue: user ? _.capitalize(user.firstName) : ''
              })(<Input id="firstName" placeholder="First Name" />)}
            </FormItem>
          </Col>
          <Col xs={24} sm={12}>
            <FormItem label={Label('Last Name')} hasFeedback>
              {getFieldDecorator('lastName', {
                rules: [
                  {
                    required: true,
                    message: 'Please enter last name matching ID'
                  }
                ],
                initialValue: user ? _.capitalize(user.lastName) : ''
              })(<Input id="lastName" placeholder="Last Name" />)}
            </FormItem>
          </Col>
        </Row>

        <div className="email-label">
          <label className="form-label">Email Address</label>
          {this.renderLoginLink(isLoggedIn)}
        </div>
        <FormItem hasFeedback>
          {getFieldDecorator('email', {
            rules: [
              {
                type: 'email',
                message: 'Please enter a valid email address'
              },
              {
                required: true,
                message: 'Please enter a valid email address'
              },
              {
                validator: this.isEmailExist
              }
            ],
            validateFirst: true,
            initialValue: user ? user.email : ''
          })(<Input id="email" placeholder="e.g. hello@gmail.com" />)}
        </FormItem>

        {this.renderPassword()}

        <FormItem label={Label('Phone Number')} hasFeedback>
          {getFieldDecorator('phone', {
            rules: [{ validator: this.validatePhone }],
            initialValue: user ? formatPhoneNumber(user.phone) : ''
          })(
            <Input
              onChange={this.formatPhoneNumber}
              id="phone"
              placeholder="(###) ###-####"
              type="tel"
            />
          )}
        </FormItem>
        <LoginModal wrappedComponentRef={c => (this.loginModalComponent = c)} />
      </div>
    )
  }

  renderLoginLink(isLoggedIn) {
    if (isLoggedIn) {
      return null
    }

    return (
      <span className="already-have-account">
        <span style={{ color: '#4a4a4a' }}> Already have an account? </span>
        <span className="link contact-login-link" onClick={() => this.onLoginClick()}>
          Log In
        </span>
      </span>
    )
  }

  /**
   * Renders the password fields in the form
   */
  renderPassword() {
    const { getFieldDecorator, isLoggedIn, user } = this.props

    if (isLoggedIn) {
      return null
    }
    return (
      <div>
        <div className="password-label">
          <label className="form-label">Password</label>
          <span className="password-help-text"> at least eight characters</span>
        </div>
        <FormItem hasFeedback>
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message: 'Please enter a valid password'
              },
              { validator: this.validatePassword }
            ],
            initialValue: user ? user.password : ''
          })(<Input id="password" placeholder="Enter here" type="password" />)}
        </FormItem>
      </div>
    )
  }
}

export default ProfileInfoFields



// WEBPACK FOOTER //
// ./src/components/login/ProfileInfoFields.js